// Scope decorative arrows to the Industrie layout; preserve text and link targets.
(function () {
  function markArrows() {
    var root = document.body;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!/[↗→➜➡]/.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (node.parentElement.closest('script,style,textarea,svg,.industry-decorative-arrow,[contenteditable]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [], current;
    while ((current = walker.nextNode())) nodes.push(current);
    nodes.forEach(function (node) {
      var fragment = document.createDocumentFragment();
      node.nodeValue.split(/([↗→➜➡]\uFE0F?)/).forEach(function (part) {
        if (/^[↗→➜➡]/.test(part)) {
          var span = document.createElement('span');
          span.className = 'industry-decorative-arrow';
          span.setAttribute('aria-hidden', 'true');
          span.textContent = part;
          fragment.appendChild(span);
        } else fragment.appendChild(document.createTextNode(part));
      });
      node.replaceWith(fragment);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markArrows, { once: true });
  else markArrows();
})();
